import React from "react";

const ProductTypeRepairReportField = ({ record }) => {
  return record.product ? (
    <div>{record.product && record.product.identification && record.product.identification.product_type}</div>
  ) : (
    <div />
  );
};

export default ProductTypeRepairReportField;
